import React from "react";
import { Navigate } from "react-router-dom";
import { isTokenExpired } from "../utils/auth";

const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem("token");

  if (isTokenExpired(token)) {
    localStorage.removeItem("token");
    return <Navigate to="/login" />;
  }

  return children;
};

export default PrivateRoute;
